// Externals
import React, { useEffect, useState } from "react";
import { navigate, useBasePath } from "raviger";

import Header from "../components/Header";
import Header2 from "../components/Header2";
import Floor from "../components/Floor/Floor";
import SuccessSlider from "../components/SuccessSlider";

import DogLookingUp from "../components/Animations/DogLookingUp";

import { useSelector } from "react-redux";

//styles
import "./EndScreen.scss";

/*::
type Props = {
}
*/
const EndScreen = (props /*: Props */) /*: React.Component */ => {
	const storeAge = useSelector((state) => state.answers.age);
	const storePostcode = useSelector((state) => state.answers.postcode);
	const basepath = useBasePath();
	const [isNSW, setIsNSW] = useState(false);
	const [isNotAus, setIsNotAus] = useState(false);
	const [isLoaded, setIsLoaded] = useState(false);

	function inRange(x, min, max) {
		return (x - min) * (x - max) <= 0;
	}

	// NSW postcode range src https://auspost.com.au/business/marketing-and-communications/access-data-and-insights/address-data/postcode-data
	// 1000-2599
	// 2620 - 2899
	// 2921 - 2999

	useEffect(() => {
		if (storePostcode) {
			if (
				inRange(storePostcode, 1000, 2599) ||
				inRange(storePostcode, 2620, 2899) ||
				inRange(storePostcode, 2921, 2999)
			) {
				setIsNSW(true);
			} else {
				setIsNSW(false);
			}
			setIsLoaded(true);
		} else {
			setIsNotAus(true);
			setIsLoaded(true);
		}
	}, [storePostcode]);
	return (
		<div className="end-screen">
			<Header />
			<Header2 />
			<div className="end-screen-container">
				{isLoaded && (
					<div className="end-screen-content">
						{storeAge < 18 ? (
							<>
								<div className="header-text">
									Looks like you are under 18 years old.
								</div>
								<div className="sub-text">
									To be matched with your Competitlbe friend
									you must be over 18.
									<br /> Make sure you visit the website of
									your local shelter, rescue or pound with
									your parent or guardian, to find a suitable
									dog for you.
									{!isNotAus && (
										<div className="button-container">
											<button>OK, View matches</button>
										</div>
									)}
								</div>
							</>
						) : (
							<>
								{isNotAus ? (
									<>
										<div className="header-text">
											Looks like you are based outside of
											Australia!
										</div>
										<div className="sub-text">
											RSPCA NSW doesn’t offer
											international adoptions. Make sure
											you visit the website of your local
											shelter, rescue or pound to find a
											suitable dog for you.
										</div>
									</>
								) : (
									<>
										{!isNSW ? (
											<>
												<div className="header-text">
													You're not in NSW, but our
													dogs are...
												</div>
												<div className="sub-text">
													You can still view your
													competible matches, but
													you'll need to visit our
													shelters to meet your furry
													friend.
													<div className="button-container">
														<button
															onClick={() =>
																navigate(
																	basepath +
																		"/results",
																)
															}
														>
															OK, View matches
														</button>
													</div>
												</div>
											</>
										) : (
											<>
												<div className="header-text">
													Sorry, you have no
													Competible™ matches at the
													moment.
												</div>
												<div className="sub-text">
													Finding your Competible
													friend can take a little
													time, but don’t worry, we’ll
													email you as soon as you
													have a match.
												</div>
											</>
										)}
									</>
								)}
							</>
						)}

						<div className="matches-animation">
							<DogLookingUp />
						</div>
						<div className="make-a-difference">
							RSPCA NSW has matched over <span>2498</span> <br />
							dogs with their Competible humans last year.
						</div>
						<div className="success-stories">
							<div className="success-header-text">
								Success Stories
							</div>
							<SuccessSlider />
						</div>
						<div className="button-container">
							<button
								onClick={() =>
									window.open("https://www.rspcansw.org.au/")
								}
								className="blue"
							>
								RSPCA site
							</button>
							<button
								onClick={() =>
									window.open(
										"https://www.rspcansw.org.au/donate/",
									)
								}
							>
								Donate Now
							</button>
						</div>
					</div>
				)}
				<Floor id={5} />
			</div>
		</div>
	);
};

// Exports
export default EndScreen;
